import {
  type CohortBuilderDefinitionLegacy,
  SubjectVariableCriteriaSelectionTypeLegacy,
} from '@verantos-dev/types-cohorts';

import {
  OBSERVATION_PERIOD_BASELINE_RESTRICTION,
  OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION,
  STUDY_PERIOD_RESTRICTION,
} from '../constants/constants';

export const getCohortBuilderItemNameAndIdMaps = (
  cohortDefinition: CohortBuilderDefinitionLegacy | undefined
) => {
  const cohortBuilderItemIdsToNamesMap: Record<string, string> = {};
  const cohortBuilderItemNamesToIdsMap: Record<string, string> = {};

  cohortBuilderItemIdsToNamesMap[SubjectVariableCriteriaSelectionTypeLegacy.INCLUSION] =
    'Inclusion criteria';
  cohortBuilderItemIdsToNamesMap[SubjectVariableCriteriaSelectionTypeLegacy.EXCLUSION] =
    'Exclusion criteria';

  /**
   * Get the current subject variable {name, id} pairs
   */
  cohortDefinition?.subjectVariables.forEach(({ id, name, type }) => {
    cohortBuilderItemIdsToNamesMap[id] = `Subject variable - ${type} - ${name}`;
    cohortBuilderItemNamesToIdsMap[name] = id;
  });

  /**
   * Study Period
   */
  if (cohortDefinition?.studyPeriodRestrictions?.overallStudyPeriodRestriction?.isEnabled) {
    cohortBuilderItemIdsToNamesMap[STUDY_PERIOD_RESTRICTION] = STUDY_PERIOD_RESTRICTION;
    cohortBuilderItemNamesToIdsMap[STUDY_PERIOD_RESTRICTION] = STUDY_PERIOD_RESTRICTION;
  }

  /**
   * Observation Period
   */
  if (cohortDefinition?.studyPeriodRestrictions?.baselinePeriodRestriction?.isEnabled) {
    cohortBuilderItemIdsToNamesMap[OBSERVATION_PERIOD_BASELINE_RESTRICTION] =
      OBSERVATION_PERIOD_BASELINE_RESTRICTION;
    cohortBuilderItemNamesToIdsMap[OBSERVATION_PERIOD_BASELINE_RESTRICTION] =
      OBSERVATION_PERIOD_BASELINE_RESTRICTION;
  }
  if (cohortDefinition?.studyPeriodRestrictions?.followUpPeriodRestriction?.isEnabled) {
    cohortBuilderItemIdsToNamesMap[OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION] =
      OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION;
    cohortBuilderItemNamesToIdsMap[OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION] =
      OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION;
  }

  /**
   * Get the current index date {name, id} pairs
   */
  if (cohortDefinition?.indexDate) {
    cohortBuilderItemIdsToNamesMap[cohortDefinition.indexDate.id] = 'Index date';
    cohortBuilderItemNamesToIdsMap['Index date'] = cohortDefinition.indexDate.id;
  }

  /**
   * Get the current derived event {name, id} pairs
   */
  cohortDefinition?.derivedEvents.forEach(({ id, name, type }) => {
    cohortBuilderItemIdsToNamesMap[id] = `Derived event - ${type} - ${name}`;
    cohortBuilderItemNamesToIdsMap[name] = id;
  });

  /**
   * Get the current simple event {name, id} pairs
   */
  cohortDefinition?.simpleEvents.forEach(({ id, name, type }) => {
    cohortBuilderItemIdsToNamesMap[id] = `Simple event - ${type} - ${name}`;
    cohortBuilderItemNamesToIdsMap[name] = id;
  });

  return {
    cohortBuilderItemIdsToNamesMap,
    cohortBuilderItemNamesToIdsMap,
  };
};
